import { render, staticRenderFns } from "./MyCustomExample.vue?vue&type=template&id=4e667e76&"
import script from "./MyCustomExample.vue?vue&type=script&lang=js&"
export * from "./MyCustomExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports